// extracted by mini-css-extract-plugin
export default {"content":"Title-module__content-B2Gb","large":"Title-module__large-PL_2"};